import styles from "../../PricingTool.module.css";

interface Props {
  value: number;
  max: number;
  step: number;
  cost: number;
  costMax: number;
  onChange: (v: number) => void;
}

export default function PriceSlider({ value, max, step, cost, costMax, onChange }: Props) {
  const clamp = (x: number) => Math.max(0, Math.min(100, x));
  const valPos = clamp((value / max) * 100);
  const costPos = clamp((cost / costMax) * 100);
  const grad =
    valPos >= costPos
      ? `linear-gradient(90deg,#ff4d4f 0 ${costPos}%,#52c41a ${costPos}% ${valPos}%,#e6e6ff ${valPos}% 100%)`
      : `linear-gradient(90deg,#ff4d4f 0 ${valPos}%,#ffc9c9 ${valPos}% ${costPos}%,#e6e6ff ${costPos}% 100%)`;

  return (
    <input
      type="range"
      className={styles.range_input}
      min={0} max={max} step={step}
      value={Math.min(value, max)}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      style={{ background: grad }}
    />
  );
}
